<template>
  <gas-page-shell :breadcrumb="['系统设置', '菜单管理']">
  <div class="page-inner">
    <div class="page-head">
      <div class="table-title-group">
        <h3>菜单管理</h3>
        <gas-table-toolbar
          :columns="tableColumnDefs"
          :visible-map.sync="tableColumnVisible"
          :selected-count="selectedIds.length"
          :show-batch-delete="tableCanBatchDelete"
          @batch-delete="batchRemove"
        />
      </div>
      <el-button type="primary" size="small" @click="openCreate()">新增菜单</el-button>
    </div>

    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="菜单名称">
        <el-input v-model="query.menuName" clearable placeholder="请输入菜单名称" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="全部">
          <el-option label="正常" value="0" />
          <el-option label="停用" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="list"
      v-loading="loading"
      row-key="menuId"
      border
      default-expand-all
      size="small"
      :tree-props="{ children: 'children' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column prop="menuName" label="菜单名称" min-width="240">
        <template slot-scope="scope">
          <i :class="iconClass(scope.row)" class="menu-icon"></i>
          <span>{{ scope.row.menuName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="menuType" label="类型" width="110">
        <template slot-scope="scope">
          <el-tag :type="typeTag(scope.row.menuType)" size="small">{{ typeText(scope.row.menuType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="排序" width="130">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.orderNum"
            size="mini"
            :min="0"
            controls-position="right"
            @change="quickSaveOrder(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="perms" label="权限标识" min-width="180" show-overflow-tooltip />
      <el-table-column prop="component" label="组件路径" min-width="220" show-overflow-tooltip />
      <el-table-column prop="path" label="路由地址" min-width="150" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <gas-status-tag kind="org" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">修改</el-button>
          <el-button type="text" size="small" @click="openCreate(scope.row)">新增</el-button>
          <el-button type="text" size="small" class="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" @close="iconPickerVisible = false">
      <el-form :model="form" label-width="100px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="上级菜单">
              <el-select v-model="form.parentId" filterable style="width:100%">
                <el-option label="主目录" :value="0" />
                <el-option
                  v-for="item in parentOptions"
                  :key="item.menuId"
                  :label="item.label"
                  :value="item.menuId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单类型">
              <el-radio-group v-model="form.menuType">
                <el-radio label="M">目录</el-radio>
                <el-radio label="C">菜单</el-radio>
                <el-radio label="F">按钮</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="菜单名称"><el-input v-model="form.menuName" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="显示排序"><el-input-number v-model="form.orderNum" :min="0" style="width:100%" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="路由地址"><el-input v-model="form.path" placeholder="/system 或 user" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="组件路径"><el-input v-model="form.component" placeholder="system/user/index" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="权限标识"><el-input v-model="form.perms" placeholder="system:user:list" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="菜单图标">
              <el-popover
                v-model="iconPickerVisible"
                placement="bottom-start"
                width="420"
                trigger="click"
                popper-class="menu-icon-picker"
              >
                <div class="icon-picker">
                  <div class="icon-picker-head">
                    <span>常用 Element 图标</span>
                    <el-button type="text" size="mini" @click="clearIcon">清除图标</el-button>
                  </div>
                  <div class="icon-grid">
                    <div
                      v-for="name in iconOptions"
                      :key="name"
                      class="icon-cell"
                      :class="{ active: form.icon === name }"
                      :title="name"
                      @click="pickIcon(name)"
                    >
                      <i :class="name"></i>
                    </div>
                  </div>
                </div>
                <el-input
                  slot="reference"
                  :value="form.icon"
                  readonly
                  placeholder="点击选择图标"
                  class="icon-input"
                >
                  <i v-if="form.icon" slot="prefix" :class="['icon-preview', form.icon]"></i>
                  <i slot="suffix" class="el-icon-arrow-down"></i>
                </el-input>
              </el-popover>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio label="0">正常</el-radio>
                <el-radio label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasTableEnhance from '@/mixins/gasTableEnhance'
import { menuApi } from '@/api/system'

const emptyForm = () => ({
  menuId: null,
  parentId: 0,
  menuName: '',
  path: '',
  component: '',
  perms: '',
  menuType: 'M',
  icon: '',
  orderNum: 0,
  status: '0'
})

const emptyQuery = () => ({ menuName: '', status: '' })

/** 菜单图标选择器常用的 Element UI 图标 */
const MENU_ICON_OPTIONS = [
  'el-icon-menu', 'el-icon-s-home', 'el-icon-s-platform', 'el-icon-monitor',
  'el-icon-odometer', 'el-icon-data-line', 'el-icon-data-analysis', 'el-icon-pie-chart',
  'el-icon-timer', 'el-icon-s-data', 'el-icon-s-order', 'el-icon-s-management',
  'el-icon-s-marketing', 'el-icon-tickets', 'el-icon-document', 'el-icon-files',
  'el-icon-notebook-2', 'el-icon-folder', 'el-icon-folder-opened', 'el-icon-s-grid',
  'el-icon-s-custom', 'el-icon-user', 'el-icon-user-solid', 'el-icon-s-check',
  'el-icon-s-claim', 'el-icon-s-flag', 'el-icon-s-opportunity', 'el-icon-s-release',
  'el-icon-s-promotion', 'el-icon-s-cooperation', 'el-icon-s-tools', 'el-icon-setting',
  'el-icon-s-finance', 'el-icon-s-goods', 'el-icon-s-shop', 'el-icon-shopping-cart-full',
  'el-icon-goods', 'el-icon-box', 'el-icon-wallet', 'el-icon-coin',
  'el-icon-location', 'el-icon-map-location', 'el-icon-place', 'el-icon-connection',
  'el-icon-link', 'el-icon-cpu', 'el-icon-bell', 'el-icon-message',
  'el-icon-chat-dot-square', 'el-icon-phone', 'el-icon-warning', 'el-icon-warning-outline',
  'el-icon-info', 'el-icon-question', 'el-icon-lock', 'el-icon-key',
  'el-icon-time', 'el-icon-date', 'el-icon-alarm-clock', 'el-icon-refresh',
  'el-icon-search', 'el-icon-sort', 'el-icon-star-on', 'el-icon-medal',
  'el-icon-trophy', 'el-icon-suitcase', 'el-icon-s-operation', 'el-icon-s-comment'
]

export default {
  components: { GasPageShell },
  mixins: [gasTableEnhance],
  data() {
    return {
      idField: 'menuId',
      removeApi: menuApi.remove,
      batchRemoveApi: menuApi.batchRemove,
      loading: false,
      list: [],
      query: emptyQuery(),
      dialogVisible: false,
      dialogTitle: '新增菜单',
      iconPickerVisible: false,
      iconOptions: MENU_ICON_OPTIONS,
      form: emptyForm()
    }
  },
  computed: {
    parentOptions() {
      const options = []
      const walk = (nodes, level) => {
        nodes.forEach(node => {
          if (node.menuId !== this.form.menuId) {
            options.push({ menuId: node.menuId, label: `${'　'.repeat(level)}${node.menuName}` })
          }
          if (node.children && node.children.length) walk(node.children, level + 1)
        })
      }
      walk(this.list, 0)
      return options
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await menuApi.list(this.query)
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    search() {
      this.loadData()
    },
    resetSearch() {
      this.query = emptyQuery()
      this.loadData()
    },
    openCreate(parent) {
      this.dialogTitle = '新增菜单'
      this.form = emptyForm()
      if (parent) {
        this.form.parentId = parent.menuId
        this.form.menuType = parent.menuType === 'M' ? 'C' : 'F'
      }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.dialogTitle = '修改菜单'
      this.form = { ...emptyForm(), ...this.cleanPayload(row) }
      this.dialogVisible = true
    },
    async submit() {
      if (!this.form.menuName) {
        this.$message.warning('请填写菜单名称')
        return
      }
      if (this.form.menuId) await menuApi.update(this.cleanPayload(this.form))
      else await menuApi.create(this.cleanPayload(this.form))
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.loadData()
    },
    async quickSaveOrder(row) {
      await menuApi.update(this.cleanPayload(row))
      this.$message.success('排序已保存')
    },
    async remove(row) {
      await this.$confirm(`确认删除菜单 ${row.menuName}？`, '提示', { type: 'warning' })
      await menuApi.remove(row.menuId)
      this.$message.success('删除成功')
      this.loadData()
    },
    cleanPayload(row) {
      const { children, ...payload } = row
      return payload
    },
    pickIcon(name) {
      this.form.icon = name
      this.iconPickerVisible = false
    },
    clearIcon() {
      this.form.icon = ''
      this.iconPickerVisible = false
    },
    typeText(type) {
      return type === 'M' ? '目录' : type === 'C' ? '菜单' : '按钮'
    },
    typeTag(type) {
      return type === 'M' ? '' : type === 'C' ? 'success' : 'warning'
    },
    iconClass(row) {
      if (row.icon && row.icon.indexOf('el-icon') === 0) return row.icon
      if (row.menuType === 'M') return 'el-icon-folder-opened'
      if (row.menuType === 'C') return 'el-icon-menu'
      return 'el-icon-key'
    }
  }
}
</script>

<style scoped>
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.search-form { margin-bottom: 12px; }
.menu-icon { margin-right: 8px; color: #606266; }
.danger { color: #f56c6c; }
.icon-input ::v-deep .el-input__inner { cursor: pointer; }
.icon-preview { font-size: 15px; }
.icon-picker-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; font-size: 13px; color: #606266; }
.icon-grid { display: grid; grid-template-columns: repeat(8, 1fr); gap: 6px; max-height: 240px; overflow-y: auto; }
.icon-cell { display: flex; align-items: center; justify-content: center; height: 32px; border: 1px solid #e4e7ed; border-radius: 4px; cursor: pointer; font-size: 16px; color: #606266; transition: all .15s; }
.icon-cell:hover { color: #409eff; border-color: #409eff; background: #ecf5ff; }
.icon-cell.active { color: #fff; background: #409eff; border-color: #409eff; }
::v-deep .el-input-number--mini { width: 96px; }
</style>
